import { useEffect, useMemo, useRef, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Card,
  Dropdown,
  Form,
  Grid,
  Image,
  Item,
  Label,
  Menu,
  Popup,
  Radio,
  Segment,
  Select,
} from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { useFormik } from 'formik';
import PageContainer from '../../common/PageContainer';
import { Link } from 'react-router-dom';
import { homeOfTheWeekStyleOptions } from '../email.constants';
import toast from 'react-hot-toast';
import * as $ from 'jquery';
import * as moment from 'moment';
import { DateInput } from 'semantic-ui-calendar-react';
import { defaultImages, SERVER_URL, URL_REGEX } from '../../../constants';
import PhotoSearch from '../../photos/PhotoSearch';
import SelectHomeOfTheWeekListingsModal from './SelectHomeOfTheWeekListingsModal';
import HomeOfTheWeekListing from './HomeOfTheWeekListing';
import * as yup from 'yup';
import MailChimpSection from '../MailChimpSection';
import { getQuill, QUILL_TOOLBAR } from '../../quill';
const ReactQuill = getQuill();

const AddHomesOfTheWeek = ({
  sites,
  addHotw,
  getSites,
  match,
  history,
  user,
  getHotwById,
  currentHOTW,
  updateHotw,
  deleteHotwById,
  cloneHotw,
  getHotwTestEmail,
  findTemplate,
}) => {
  const [id, setId] = useState(null);
  const [bannerImageUrl, setBannerImageUrl] = useState(defaultImages.PHOTO_PLACEHOLDER);
  const [bannerImage2Url, setBannerImage2Url] = useState(defaultImages.PHOTO_PLACEHOLDER);
  const quill = useRef();

  useEffect(() => {
    if (match.params.id) {
      setId(match.params.id);
    }
  }, [currentHOTW]);

  const modules = useMemo(() => QUILL_TOOLBAR(quill), [quill]);

  const validationSchema = yup.object({
    listingUrl: yup
      .string()
      .trim()
      .matches(URL_REGEX, 'Must be a valid URL')
      .required('A URL for the listing button is required.')
      .nullable(),
    listingButtonText: yup.string().trim().required('Listing button text is required.').nullable(),
    style: yup.string().required('Required field').nullable(),
    subject: yup.string().required('Required field').nullable(),
    bannerUrl: yup.string().trim().matches(URL_REGEX, 'Must be a valid URL').required('A URL is required.').nullable(),
    bannerAlt: yup.string().required('Required field').nullable(),
    bannerImageUrl: yup
      .string()
      .trim()
      .matches(URL_REGEX, 'Must be a valid URL')
      .optional('A photo is required.')
      .nullable(),
    // banner2Url: yup.string().optional().nullable(),
    // banner2Alt: yup.string().optional().nullable(),
    // banner2ImageUrl: yup
    //   .string()
    //   .optional('A photo is required.')
    //   .trim()
    //   .matches(URL_REGEX, 'Must be a valid URL')
    //   .nullable(),
    siteId: yup.string().required('Required field').nullable(),
    introduction: yup.string().optional('Required field').nullable(),
  });

  const UTM_MAP = {
    null: 'promo-alert',
    undefined: 'promo-alert',
    'Promo Alert': 'promo-alert',
    'Insider Invite': 'insider-invite',
  };

  const getUtm = style => `utm_source=${UTM_MAP[style]}&utm_medium=email&utm_campaign=website`;

  const initialValues = {
    style: 'Homes of the Week',
    subject: '',
    slots: [],
    bannerUrl: '',
    bannerAlt: '',
    bannerImageUrl: '',
    banner2Url: '',
    banner2Alt: '',
    banner2ImageUrl: '',
    reuseBanner: true,
    listingUrl: '',
    listingButtonText: 'VIEW ALL LISTINGS',
    siteId: '',
    introduction: '',
    utm: getUtm(currentHOTW?.style),
    sendDate: null,
    sendTime: null,
  };

  const handleSubmit = (digest, formik) => {
    digest.id ? updateHotw(digest) : addHotw(digest);
  };

  const formik = useFormik({
    enableReinitialize: true,
    onSubmit: handleSubmit,
    validationSchema,
    initialValues,
    validateOnChange: false,
    validateOnBlur: false,
  });

  useEffect(() => {
    if (!id) return;
    getHotwById(id);
  }, [id]);

  useEffect(() => {
    if (currentHOTW?.id !== id) return;
    formik.setValues({ ...currentHOTW });
    if (currentHOTW.bannerImageUrl) setBannerImageUrl(currentHOTW.bannerImageUrl);
    if (currentHOTW.banner2ImageUrl) setBannerImage2Url(currentHOTW.banner2ImageUrl);
  }, [currentHOTW]);

  useEffect(() => {
    formik.resetForm();
  }, []);

  useEffect(() => {
    formik.setFieldValue('utm', getUtm(formik.values.style));
    if (formik.values.style && formik.values.siteId) {
      const template = findTemplate(formik.values.siteId, formik.values.style);
      if (template) {
        formik.setFieldValue('emailTemplateId', template.id);
      }
    }
  }, [formik.values]);

  const moveUp = (name, post) => {
    const items = [...formik.values[name]];
    const idx = items.indexOf(post);
    if (idx - 1 < 0) return;
    const temp = items[idx - 1];
    items[idx - 1] = post;
    items[idx] = temp;
    formik.setFieldValue(name, items);
  };

  const moveDown = (name, post) => {
    const items = [...formik.values[name]];
    const idx = items.indexOf(post);
    if (idx + 1 > items.length - 1) return;
    const temp = items[idx + 1];
    items[idx + 1] = post;
    items[idx] = temp;
    formik.setFieldValue(name, [...items]);
  };

  const getUrl = url => {
    if (!url || !url.includes('image/upload/')) return url;
    return url.replace('upload', 'upload/w_500');
  };

  const sendPreviewEmail = async () => getHotwTestEmail(currentHOTW.id);

  useEffect(() => {
    console.log(formik.values);
    validationSchema
      .validate(formik.values)
      .then(console.log)
      .catch((a, b) => console.log({ a, b }));
  }, [formik.values]);

  const isValid = () => {
    try {
      validationSchema.validateSync(formik.values);
      return true;
    } catch (e) {
      return false;
    }
  };

  const start = moment().hour(0).minute(0).second(0).millisecond(0);
  const EMAIL_SEND_TIMES = _.range(0, 96).map(t => {
    const time = start.clone().add(t * 15, 'minutes');
    return {
      key: time.clone().add(15, 'minutes').format('HH:mm a'),
      value: time.clone().add(15, 'minutes').format('HH:mm:ss'),
      text: time.clone().add(15, 'minutes').format('hh:mm A'),
    };
  });

  const getPage = () => (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/hotw">Homes of the Week</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>Add Home of the Week</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless attached="top">
        <Menu.Item header>Add home of the week</Menu.Item>
      </Menu>

      <Segment attached>
        <Form onSubmit={formik.handleSubmit} widths="equal">
          <Grid>
            <Grid.Row>
              <Grid.Column width="8">
                <Form.Field error={Boolean(formik.errors.siteId)}>
                  <label htmlFor="siteId">City</label>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={sites || []}
                    id="siteId"
                    label="City"
                    placeholder="Select city"
                    name="siteId"
                    tip="The CultureMap site associated with this email."
                    value={formik.values.siteId || ''}
                    onChange={(e, d) => formik.setFieldValue('siteId', d.value)}
                  />
                </Form.Field>

                <Form.Field error={Boolean(formik.errors.style)}>
                  <label htmlFor="style">Style</label>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={homeOfTheWeekStyleOptions}
                    id="style"
                    data-testid="style"
                    tip="The email style."
                    label="Style"
                    name="style"
                    value={formik.values.style || ''}
                    onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                  />
                </Form.Field>

                <TextField
                  name="subject"
                  formik={formik}
                  value={formik.values.subject || ''}
                  onChange={e => {
                    if (e?.target?.value) {
                      e.target.value = $($.parseHTML(e.target.value)).text().substring(0, 50);
                    }
                    formik.handleChange(e);
                  }}
                  tip="The subject line of the email subscribers will see."
                  error={Boolean(formik.errors.subject)}
                  errorMessage={formik.errors.subject}
                  label={`Subject line (Characters: ${formik.values?.subject?.length || 0})`}
                />

                {/* top banner */}

                <Segment>
                  <Label
                    ribbon
                    color="blue"
                    content={formik.values.reuseBanner ? `Top & Bottom Banner` : `Top Banner`}
                    style={{ marginBottom: 10 }}
                  />

                  <TextField
                    name="bannerUrl"
                    formik={formik}
                    value={formik.values.bannerUrl || ''}
                    tip="The URL users will be directed to after clicking on the banner image."
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.bannerUrl)}
                    errorMessage={formik.errors.bannerUrl}
                    label={`Banner URL`}
                  />

                  <TextField
                    name="bannerAlt"
                    formik={formik}
                    value={formik.values.bannerAlt || ''}
                    tip="The alt text for the banner image."
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.bannerAlt)}
                    errorMessage={formik.errors.bannerAlt}
                    label={`Banner Alt Text`}
                  />

                  <Grid columns="2" style={{ marginBottom: 0, padding: `1rem` }}>
                    <Grid.Row>
                      <Image
                        src={bannerImageUrl}
                        size="medium"
                        as="a"
                        href={bannerImageUrl}
                        rel="noreferrer"
                        target="_blank"
                      />
                    </Grid.Row>
                    <Grid.Row>
                      <PhotoSearch
                        handleSelect={({ id, original }) => {
                          formik.setFieldValue(
                            'bannerImageUrl',
                            'https://res.cloudinary.com/culturemap-com/' + original
                          );
                          setBannerImageUrl('https://res.cloudinary.com/culturemap-com/' + getUrl(original));
                        }}
                      />
                      <Button
                        negative
                        icon={'trash'}
                        type="button"
                        onClick={() => {
                          formik.setFieldValue('bannerImageUrl', '');
                          setBannerImageUrl('');
                        }}
                      />
                    </Grid.Row>
                    <Grid.Row>
                      <Radio
                        toggle
                        label="Use same banner at the bottom of the email?"
                        checked={formik.values.reuseBanner}
                        onChange={(e, { checked }) => formik.setFieldValue('reuseBanner', checked)}
                      />
                    </Grid.Row>
                  </Grid>

                  {formik.errors.bannerImageUrl && (
                    <div className="error field">
                      <Label prompt basic content={formik.errors.bannerImageUrl} pointing="above" />
                    </div>
                  )}
                </Segment>

                {/* bottom banner */}
                {!formik.values.reuseBanner && (
                  <Segment>
                    <Label ribbon color="blue" content="Bottom Banner" style={{ marginBottom: 10 }} />

                    <TextField
                      name="banner2Url"
                      formik={formik}
                      value={formik.values.banner2Url || ''}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.banner2Url)}
                      errorMessage={formik.errors.banner2Url}
                      tip="The URL users will be directed to after clicking on the banner image."
                      label={`Banner URL (Bottom)`}
                    />

                    <TextField
                      name="banner2Alt"
                      formik={formik}
                      value={formik.values.banner2Alt || ''}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.banner2Alt)}
                      errorMessage={formik.errors.banner2Alt}
                      tip="The alt text for the bottom banner image."
                      label={`Banner Alt Text (Bottom)`}
                    />

                    <Grid columns="2" style={{ marginBottom: 0, padding: `1rem` }}>
                      <Grid.Row>
                        <Image
                          src={bannerImage2Url}
                          size="medium"
                          as="a"
                          href={bannerImage2Url}
                          rel="noreferrer"
                          target="_blank"
                        />
                      </Grid.Row>
                      <Grid.Row>
                        <PhotoSearch
                          handleSelect={({ id, original }) => {
                            formik.setFieldValue(
                              'banner2ImageUrl',
                              'https://res.cloudinary.com/culturemap-com/' + original
                            );
                            setBannerImage2Url('https://res.cloudinary.com/culturemap-com/' + getUrl(original));
                          }}
                        />
                        <Button
                          negative
                          icon={'trash'}
                          type="button"
                          onClick={() => {
                            formik.setFieldValue('banner2ImageUrl', '');
                            setBannerImage2Url('');
                          }}
                        />
                      </Grid.Row>
                    </Grid>

                    {formik.errors.bannerImage2Url && (
                      <div className="error field">
                        <Label prompt basic content={formik.errors.bannerImage2Url} pointing="above" />
                      </div>
                    )}
                  </Segment>
                )}

                <TextField
                  name="listingUrl"
                  formik={formik}
                  value={formik.values.listingUrl || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.listingUrl)}
                  errorMessage={formik.errors.listingUrl}
                  tip="The URL associated with the 'View All Listings' button"
                  label={`Button URL`}
                />

                <TextField
                  name="listingButtonText"
                  formik={formik}
                  value={formik.values.listingButtonText || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.listingButtonText)}
                  errorMessage={formik.errors.listingButtonText}
                  tip="The text for the 'View All Listings' button"
                  label={`Button text`}
                />

                <Form.Field>
                  <label>Introduction</label>
                  <ReactQuill
                    modules={modules}
                    ref={quill}
                    value={formik.values.introduction || ''}
                    onChange={(e, { value }) => formik.setFieldValue('introduction', e)}
                    style={{ height: 200, backgroundColor: formik.errors.introduction ? '#FFF5F6' : 'white' }}
                  />
                </Form.Field>

                <br />
                <br />

                {formik.errors.introduction && (
                  <div className="error field">
                    <Label prompt basic content={formik.errors.introduction} pointing="above" />
                  </div>
                )}

                <br />
                <Form.Field>
                  <Popup content="The date you want the email sent to subscribers" trigger={<label>Send date</label>} />
                  <DateInput
                    closable={true}
                    name="sendDate"
                    placeholder="Send date"
                    popupPosition="bottom center"
                    minDate={moment().format('L')}
                    value={formik.values.sendDate || ''}
                    iconPosition="left"
                    dateFormat="YYYY-MM-DD"
                    onChange={(e, { value }) => formik.setFieldValue('sendDate', value ?? null)}
                  />
                </Form.Field>
                <Form.Field width={4}>
                  <label>Send time</label>

                  <Select
                    options={EMAIL_SEND_TIMES}
                    id="sendTime"
                    name="sendTime"
                    clearable
                    value={formik.values.sendTime || ''}
                    error={Boolean(formik.errors.sendTime)}
                    onChange={(e, { value }) => formik.setFieldValue('sendTime', value ? value : null)}
                  />

                  {/* {formik.errors.sendTime && <Label basic style={errorStyle} pointing content={formik.errors.sendTime} />} */}
                </Form.Field>

                <Form.Field>
                  <TextField
                    name="utm"
                    formik={formik}
                    value={formik.values.utm || ''}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.utm)}
                    errorMessage={formik.errors.utm}
                    label="UTM campaign"
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Segment>

      <Card fluid>
        <Card.Content>
          <Grid>
            <Grid.Column width="12">
              <h5>Slots</h5>
            </Grid.Column>
            <Grid.Column width="4">
              <SelectHomeOfTheWeekListingsModal
                slots={formik.values.slots}
                handleSelection={listingIds => formik.setFieldValue('slots', listingIds)}
              />
            </Grid.Column>
          </Grid>
        </Card.Content>
        <Card.Content>
          <Item.Group divided>
            {formik.values.slots?.map((listingId, idx) => (
              <HomeOfTheWeekListing
                key={idx}
                listingId={listingId}
                formik={formik}
                slots={formik.values?.slots}
                moveUp={() => moveUp('slots', listingId)}
                moveDown={() => moveDown('slots', listingId)}
                removeItem={() =>
                  formik.setFieldValue('slots', [...formik.values.slots.filter(id => id !== listingId)])
                }
              />
            ))}
            <Item></Item>
          </Item.Group>
        </Card.Content>
      </Card>

      <Form>
        <Button
          color="green"
          content="Save"
          onClick={() => {
            formik.validateForm().then(err => {
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm();
                setTimeout(() => history.push('/hotw'), 2000);
              }
            });
          }}
        />
        <Button
          color="green"
          content="Clone"
          type="button"
          onClick={() => {
            const { id, ...data } = formik.values;
            cloneHotw(data);
          }}
        />
        <Button
          color="green"
          content="Save and continue editing"
          onClick={() => {
            formik.validateForm().then(err => {
              console.log({ err });
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm();
              }
            });
          }}
        />
        <Button
          icon="binoculars"
          as="a"
          target="_blank"
          content="Save & Preview"
          onClick={() => {
            formik.validateForm().then(err => {
              console.log({ err });
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm().then(res => {
                  //open new tab with preview
                  // wait 2 second for the data to be saved
                  setTimeout(() => {
                    window.open(`${SERVER_URL}/api/hotw/email/${currentHOTW.id}`, '_blank');
                  }, 2000);
                });
              }
            });
          }}
        />

        <Button
          icon="envelope"
          disabled={!isValid()}
          // disabled={!formik.isValid || formik.isSubmitting}
          content="Send Test Email"
          onClick={sendPreviewEmail}
        />

        <Button
          icon="envelope"
          content="Schedule Email"
          disabled={
            !formik.values.sendTime ||
            !formik.values.sendDate ||
            !isValid() ||
            !formik.values.mailchimpCampaignId ||
            currentHOTW?.isScheduled
          }
          onClick={() => {
            formik.setFieldValue('isScheduled', true);
            formik.validateForm().then(err => {
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm();
              }
            });
          }}
        />

        <Popup
          closeOnPortalMouseLeave
          trigger={
            <Button floated="right" disabled={formik.values.isScheduled} content="Delete" negative icon="trash" />
          }
          content={<Button color="green" content="Are you sure?" onClick={() => deleteHotwById(id)} />}
          on="click"
          position="bottom left"
        />
      </Form>

      <br />
      {formik && formik.values.id && <MailChimpSection id={id} user={user} formik={formik} />}
    </PageContainer>
  );

  return <>{currentHOTW?.id === id && getPage()}</>;
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  cities: selectors.getCityOptions(state),
  sites: selectors.getSiteOptions(state),
  searchPostResults: selectors.getSearchPosts(state),
  currentHOTW: selectors.getCurrentHotw(state),
  dayOptions: selectors.getDayOptions(state),
  user: selectors.users.current(state),
  findTemplate: selectors.templates.find(state),
});

const mapDispatchToProps = dispatch => ({
  addHotw: bindActionCreators(actions.campaign.addHotw, dispatch),
  cloneHotw: bindActionCreators(actions.campaign.cloneHotw, dispatch),
  updateHotw: bindActionCreators(actions.campaign.updateHotw, dispatch),
  searchPosts: bindActionCreators(actions.campaign.searchDigests, dispatch),
  getHotwById: bindActionCreators(actions.campaign.getHotwById, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  setLoading: bindActionCreators(actions.user.setLoading, dispatch),
  deleteHotwById: bindActionCreators(actions.campaign.deleteHotwById, dispatch),
  getHotwTestEmail: bindActionCreators(actions.campaign.getHotwTestEmail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddHomesOfTheWeek);
